<mat-expansion-panel
    class="w-100"
    [hideToggle]="Spinner.isShown('initForms')"
    [disabled]="Spinner.isShown('initForms')"
    [(expanded)]="expanded"
    [class.mt-12]="index !== 0">
    <mat-expansion-panel-header class="w-100"
                                [class.loading]="Spinner.isShown('initForms')"
                                fxLayout="start space-between">
        <mat-panel-title class="no-wrap t2-semi-bold">
            <div class="radius-4 bc-primary-green-100 c-primary-gray-900 pl-12 pr-12">
                {{ getTransactionTitle() }}
            </div>
        </mat-panel-title>
        @if (Spinner.isShown('initForms')) {
            <mat-panel-description fxLayoutAlign="end">
                <ui-kit-spinner [diameter]="16" [strokeWidth]="3" spinnerIds="initForms"/>
            </mat-panel-description>
        }
        @if (showDeleteButton) {
            <mat-panel-description
                fxLayoutAlign="end">
                <ui-kit-button type="text"
                               color="accent"
                               class="mr-16"
                               [spinnerId]="'deleteTransaction_'+index"
                               [isSmall]="true"
                               (clickListener)="deleteTransactionListener.emit(index)"
                               [label]="'i18n_af_buttonDeleteTransaction' | translate"/>
            </mat-panel-description>
        }
    </mat-expansion-panel-header>
    <div [fxHide]="Spinner.isShown('initForms')" class="w-100" fxLayout="column" fxLayoutAlign="start start">
        @if (expanded) {
            <af-transaction-information
                [transaction]="transaction"
                [form]="transactionForm"
                class="w-100"/>
        }
        @if (showAddTransactionButton) {
            <ui-kit-button
                type="text"
                class="mt-24"
                fxFlexAlign="start"
                iconPosition="left"
                [disabled]="isAddTransactionButtonDisabled"
                [label]="'i18n_af_buttonAddTransaction' | translate"
                icon="ic_add_circle"
                (clickListener)="addNewTransactionListener.emit()"/>
        }
    </div>
</mat-expansion-panel>
